import {
    CONTACT_LIST_REQUEST,
    CONTACT_LIST_FAIL,
    CONTACT_LIST_RESET,
    CONTACT_LIST_SUCCESS,    
    CONTACT_DETAIL_REQUEST,
    CONTACT_DETAIL_SUCCESS,
    CONTACT_DETAIL_FAIL,
    CONTACT_DETAIL_RESET
} from '../constants/contactConstants'

export const contactListReducer = (state = { contacts: [] }, action) => {
    switch (action.type) {
        case CONTACT_LIST_REQUEST:
            return { loading: true };
        case CONTACT_LIST_SUCCESS:
            return { loading: false, contacts: action.payload }
        case CONTACT_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

export const contactDetailsReducer = (state = { contactdetail: [] }, action) => {
    switch (action.type) {
        case CONTACT_DETAIL_REQUEST:
            return { loading: true };
        case CONTACT_DETAIL_SUCCESS:
            return { loading: false, contactdetail: action.payload }
        case CONTACT_DETAIL_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}